

import React, { useState, useRef, useEffect } from "react";
import "./Payment.css";
import order from "../../../../images/products/order-delivered.jpg";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import zIndex from "@mui/material/styles/zIndex";
import axios from "axios";

const Paymentdata = ({ orderId: propOrderId }) => {
  const [orderDetails, setOrderDetails] = useState(null);
  const platformCharge = 1; // or use useState if it varies { orderId: propOrderId }
  const [isApplieds, setIsApplieds] = useState(false);
  const [showNewPage, setShowNewPage] = useState(false);
  const [orderData, setOrderData] = useState({});
  // const [orderData, setOrderData] = useState({
  //   orderId: "",
  //   date: "",
  //   orderService: "",
  //   time: "",
  //   location: "",
  //   paymentMethod: "",
  //   order: []
  // });

  const [showPaymentData, setShowPaymentData] = useState(false);

  const [userId, setUserId] = useState(localStorage.getItem("userId") || 1); // Use stored userId or default 1
  const handlePayNowClick = () => {
    setShowNewPage(true); // Hide current content and show the new page
  };
  const discountAmount = orderData?.discountAmount ?? 0; // safe access & default

  // const [loading, setLoading] = useState(false);
  // const grandTotal = 849; // Extracted Grand Total value
  // Load Razorpay SDK

  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  // const [orderDatas, setOrderData] = useState(null);



  // const [orderData, setOrderData] = useState({ checkout: [] });
  const [loading, setLoading] = useState(false);



  const handleSubmitFeedback = async () => {
    const orderId = localStorage.getItem("orderId");

    if (!orderId) {
      alert("❌ No order ID found in local storage.");
      return;
    }

    const payload = {
      feedback: feedback,
      ratings: rating,
    };

    try {
      const response = await axios.post(
        `https://backend.maamaas.com/food/orders/feedback/${orderId}`,
        payload
      );

      alert("✅ Feedback submitted successfully!");
      setFeedback("");
      setRating(0);
    } catch (error) {
      console.error("❌ Failed to submit feedback:", error);
      alert("❌ Failed to submit feedback.");
    }
  };




  const {
    subTotal = 0,
    serviceCharge = 0,
    deliveryCharges = 0,
    packingCharges = 0,
    cgst = 0,
    sgst = 0,
    service = "",
  } = orderData || {};


  // Calculate grand total
  const grandTotal =
    subTotal +
    platformCharge +
    cgst +
    sgst -
    discountAmount;



  const orderId = propOrderId || localStorage.getItem("orderId");

  useEffect(() => {
    console.log("🔁 useEffect running. Current orderId:", orderId);

    if (!orderId) {
      console.warn("⚠️ No orderId found, skipping fetch.");
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        console.log("🌐 Fetching order details for:", orderId);

        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/order/${orderId}`
        );

        if (response.status === 200) {
          console.log("✅ Order details fetched:", response.data);
          setOrderData(response.data);
        } else {
          console.error("⚠️ Unexpected response:", response);
        }
      } catch (error) {
        console.error("❌ Failed to fetch order details:", error);
      }
    };

    fetchOrderDetails();
  }, [orderId]);
















  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Initiate Payment using Razorpay
  const initiatePayment = async () => {
    setLoading(true);

    const isRazorpayLoaded = await loadRazorpayScript();

    if (!isRazorpayLoaded) {
      alert('Razorpay SDK failed to load. Are you online?');
      setLoading(false);
      return;
    }

    const options = {
      key: "rzp_test_x373qXYoPx1x72",
      amount: grandTotal * 100,
      currency: "INR",
      name: "MAAMAA's HOUSE",
      description: "Test Transaction",
      handler: function (response) {
        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
        console.log("Payment Successful! Payment ID: " + response.razorpay_payment_id);
      },
      prefill: {
        name: "Your Name",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "MAAMAA's HOUSE",
      },
      theme: {
        color: "#b15dc6", // Razorpay primary color

      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();

    setTimeout(() => {
      const backdrop = document.querySelector('.razorpay-backdrop');
      if (backdrop) {
        backdrop.style.backgroundColor = 'transparent';
        backdrop.style.width = '80vw'; // 80% of the viewport width
        backdrop.style.height = '80vh'; // 80% of the viewport height
        backdrop.style.borderRadius = '16px'; // Optional for rounded corners
        backdrop.style.margin = 'auto'; // Center it if necessary
      }
    }, 500); // Adjust timing if necessary
    // Adjust timing if necessary
    setTimeout(() => {
      const razorpayFrame = document.querySelector('.razorpay-checkout-frame');
      if (razorpayFrame) {
        razorpayFrame.style.transform = 'scale(0.8) translateX(-4vw)';
        razorpayFrame.style.transformOrigin = 'start';
      }
    }, 500);

    paymentObject.on("payment.failed", function (response) {
      alert("Payment failed. Please try again.");
      console.error(response.error);
    });

    setLoading(false);
  };

  // Handle Checkbox Click
  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      initiatePayment();
    }
  };




  const printRef = useRef(); // Reference for printable content

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Restore original content
  };

  const handleDownload = () => {
    const receipt = document.querySelector(".three");

    // Temporarily disable scrolling and set auto height
    const originalStyle = {
      height: receipt.style.height,
      overflowY: receipt.style.overflowY
    };
    receipt.style.height = "auto";
    receipt.style.overflowY = "visible";

    html2canvas(receipt, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
      pdf.save("Payment_Receipt.pdf");

      // Restore original styles
      receipt.style.height = originalStyle.height;
      receipt.style.overflowY = originalStyle.overflowY;
    });
  };
  const [bannerData, setBannerData] = useState(null);

  const [error, setError] = useState("");

  const vendorId = localStorage.getItem("vendorId");

  useEffect(() => {
    if (!vendorId) return;

    const source = axios.CancelToken.source();

    (async () => {
      try {
        setLoading(true);

        const { data } = await axios.get(
          `https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
          { cancelToken: source.token }                 // ⬅️ no headers now
        );

        // 🔽 massage the fields once
        setBannerData({
          ...data,
          companyName: data.companyName || "No Name",

        });
        setError("");
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error(err);
          setError("Could not load banner details.");
        }
      } finally {
        setLoading(false);
      }
    })();

    return () => source.cancel();
  }, [vendorId]);



  return (
    <div className="paymentdata-screen" style={{ marginTop: '-40px', marginLeft: "0px", scrollbarWidth: "none", }}>


      <div ref={printRef} className="three" style={{ height: '520px', background: 'rgb(177, 93, 198)', borderRadius: '10px', overflowY: "auto", scrollbarWidth: 'none' }}>
        <div className="paymentpage">
          <img src={order} alt="image1" style={{ height: "50px", borderRadius: "50%", marginLeft: "0px", marginTop: "20px" }} />
          <h3 style={{ color: "#fff", marginTop: "30px", marginLeft: "20px" }}>Payment successful!!!</h3>
        </div>
        <hr style={{ border: "1px solid black", }} />
        <h5 className="house"> {bannerData?.companyName || "MAAMAAS"}</h5>
        <div className="four row paymentdata-screensrw" style={{ marginLeft: "9px", marginTop: "20px" }}>
          <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
            <dt style={{ minWidth: "150px" }}>Order ID</dt>
            <dd style={{ minWidth: "30px" }}>:</dd>
            <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>{orderData.orderId}</dd>
          </div>
          <div style={{ color: "#fff", fontSize: "18px", }} className="col-lg-6 p list1">
            <dt style={{ minWidth: "150px" }}>Date</dt>
            <dd style={{ minWidth: "30px" }}>:</dd>
            <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
              {orderData.date ? new Date().toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
            </dd>

          </div>

          <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
            <dt style={{ minWidth: "150px" }}>Order Type</dt>
            <dd style={{ minWidth: "30px" }}>:</dd>
            <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
              {orderData.orderType}
            </dd>
          </div>

          <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
            <dt style={{ minWidth: "150px" }}>Time</dt>
            <dd style={{ minWidth: "30px" }}>:</dd>
            <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
              {orderData.time ? new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
            </dd>
          </div>



          {orderData?.orderService === "Delivery" ? (
            // Show location instead of outlet
            <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
              <dt style={{ minWidth: "150px" }}>Delivery Location</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
                {orderData?.location || "N/A"}
              </dd>
            </div>
          ) : (
            // Show outlet if it's not delivery
            <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
              <dt style={{ minWidth: "150px" }}>Outlet</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
                kphb Manjeera Trinity
                <br /> 3rd gate straight line
              </dd>
            </div>
          )}


          <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
            <dt style={{ minWidth: "150px" }}>Payment Method</dt>
            <dd style={{ minWidth: "30px" }}>:</dd>
            <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}> {orderData.paymentMethod || "N/A"}</dd>

          </div>

        </div>
        <hr style={{ border: "1px solid black", }} />

        {loading ? (
          <p>Loading...</p>
        ) : Array.isArray(orderData.order) && orderData.order.length > 0 ? (
          <>
            <table
              className="order-table"
              style={{ marginLeft: "10px", fontSize: "20px", fontWeight: "bold" }}
            >
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Price (₹)</th>
                  <th>Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {orderData.order.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.dishName || item.order?.dishName || "N/A"}</td>
                    <td>{item.quantity ?? "N/A"}</td>
                    <td>{item.price ? item.price.toFixed(2) : "0.00"}</td>
                    <td>
                      {item.price && item.quantity
                        ? (item.price * item.quantity).toFixed(2)
                        : "0.00"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <hr style={{ border: "1px dashed black", }} />
            {/* Totals Section */}
            <div style={{ marginTop: "20px" }}>
              <dl
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "30px",
                  fontSize: "15px",
                }}
              >
                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                  Sub Total
                </dt>
                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                  ₹{orderData?.subTotal ?? "0.00"}
                </dt>
              </dl>
            </div>


            <div>
              <dl
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "30px",
                  fontSize: "15px",
                }}
              >
                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                  Platform Charges
                </dt>
                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                  ₹{platformCharge ?? "0.00"}
                </dt>
              </dl>
            </div>
            <div>
              <dl
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "30px",
                  fontSize: "15px",
                }}
              >
                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                  CGST
                </dt>
                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                  ₹{cgst ?? "0.00"}
                </dt>
              </dl>
            </div>
            <div>
              <dl
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "30px",
                  fontSize: "15px",
                }}
              >
                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                  SGST
                </dt>
                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                  ₹{sgst
                    ?? "0.00"}
                </dt>
              </dl>
            </div>
            <hr style={{ border: "1px dashed black", }} />
            <div>
              <dl
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "30px",
                  fontSize: "15px",
                }}
              >
                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "23px" }}>
                  Grand Total
                </dt>
                <dt style={{ minWidth: "60px", fontSize: "23px" }}>
                  ₹{orderData?.grandTotal ?? "0.00"}
                </dt>
              </dl>
            </div>
          </>
        ) : (
          <p>No order data available.</p>
        )}


        {/* {applied && coupon && ( */}



        {/* )} */}


        <div>

          {/* </div> */}


          <div className="thankyou">

            <h5 style={{ color: "#fff", fontWeight: "bold", fontSize: "24px" }}>Thank You!!! Visit Again.....</h5>
            <p style={{ color: "#ddd", fontSize: "18px" }}>www.maamaas.com</p>
            <div className="buttons-data" style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
              <button className="pdfbutton" onClick={handlePrint}>Print</button>
              <button className="pdfbutton" onClick={handleDownload}>⬇️Download</button>
            </div>
          </div>
          {/* <div style={{
            display: window.innerWidth <= 768 ? 'none' : 'block',
            backgroundColor: "rgb(177 93 198)",
            padding: "30px",
            justifyContent: "center",
            fontFamily: "Arial, sans-serif"
            }}>
            <div style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              maxWidth: "960px",
              width: "100%"
            }}>
              <div style={{
                padding: "30px",
                maxWidth: "900px",
                margin: "auto",
                fontFamily: "Arial, sans-serif",
                display: "flex",
                gap: "20px"
              }}>

                <div style={{
                  flex: 1,
                  backgroundColor: "#f1f8e9",
                  padding: "20px",
                  borderRadius: "10px"
                }}>
                  <h3 style={{ marginBottom: "10px", color: "#333", textAlign: "center" }}>Your Feedback</h3>
                  <textarea
                    rows="6"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Write your feedback here..."
                    style={{
                      width: "100%",
                      height: "50px",
                      padding: "12px",
                      fontSize: "14px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      resize: "none"
                    }}
                  />
                </div>

                <div style={{
                  flex: 1,
                  backgroundColor: "rgb(241 248 233)",
                  padding: "20px",
                  borderRadius: "10px"
                }}>
                  <h3 style={{ marginBottom: "10px", color: "#333", textAlign: "center" }}>Rate Us</h3>
                  <div style={{ fontSize: "30px", display: "flex", gap: "10px" }}>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        style={{
                          cursor: "pointer",
                          color: (hover || rating) >= star ? "#ff9800" : "#ccc",
                          transition: "color 0.2s"
                        }}
                        onMouseEnter={() => setHover(star)}
                        onMouseLeave={() => setHover(0)}
                        onClick={() => setRating(star)}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                  <p style={{ marginTop: "10px", fontSize: "14px", color: "#555", textAlign: "center" }}>
                    {rating > 0 ? `You rated ${rating} star${rating > 1 ? "s" : ""}` : "Click stars to rate"}
                  </p>
                </div>
              </div>

              <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <button
                  onClick={handleSubmitFeedback}
                  style={{
                    backgroundColor: "green",
                    color: "#fff",
                    border: "none",
                    height: "30px",
                    borderRadius: "5px",
                    padding: "0 20px",
                    fontSize: "15px",
                    cursor: "pointer"
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div> */}

        </div>
      </div>






      {/* Footer */}
      <div style={footerStyle}>
        @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
      </div>
    </div>
  );
};

// Styles
const selectStyle = {
  width: "800px",
  height: "60px",
  background: "rgb(177, 93, 198)",
  borderRadius: "10px",
  marginLeft: "-160px",
  marginTop: "20px",
  padding: "15px",
  color: "#fff",
  fontWeight: "bold",
  border: "0px",
  fontSize: "20px",
};

const footerStyle = {
  zIndex: "99",
  position: "fixed",
  bottom: "0px",
  left: "0px",
  height: "30px",
  width: "100%",
  backgroundColor: "white",
  color: "black",
  textAlign: "center",
  padding: "5px",
  fontWeight: "bold",
  fontSize: "14px",
  boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
};

export default Paymentdata;











































